import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";

const InspectionProcessCard = ({children}) => {
    return (
        <div styleName={"styles.card"}>
            {children}
        </div>
    );
};

InspectionProcessCard.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export default InspectionProcessCard;
